import React from 'react';
import cn from 'classnames';
import styles from './ModalButtons.module.scss';
const ModalButtons = ({ bottom, children, fullWidth = false, className, isModalCompressed = false, }) => {
    return (React.createElement("div", { className: cn(bottom && styles.bottom, styles.container, fullWidth && styles.fullWidth, className, isModalCompressed && styles.compressedModal), role: "group" }, React.Children.map(children, (child) => {
        return React.createElement("div", { className: cn(styles.buttonHolder, fullWidth && styles.fullWidth) }, child);
    })));
};
export default ModalButtons;
//# sourceMappingURL=ModalButtons.js.map